import { useState, useCallback } from 'react';

/**
 * 弹窗相关状态管理 hook
 * @returns {Object} 包含所有弹窗状态和操作方法的对象
 */
export const usePupData = () => {
  // 当前选中的标签页索引
  const [tabActive, setTabActive] = useState(0);
  // 当前选中的语音项
  const [selectVoiceItem, setSelectVoiceItem] = useState({});
  // 当前使用的语音项
  const [useVoiceItem, setUseVoiceItem] = useState({});
  // 控制语音列表弹窗显示状态
  const [showVoiceLost, setShowVoiceList] = useState(false);
  // 控制通知显示状态
  const [showNotification, setShowNotification] = useState(false);
  // 控制创建类型模态框显示状态
  const [showCreateTypeModal, setShowCreateTypeModal] = useState(false);
  // 控制上传音频模态框显示状态
  const [showUploadAudioModal, setShowUploadAudioModal] = useState(false);
  // 控制录音模态框显示状态
  const [showRecordAudioModal, setShowRecordAudioModal] = useState(false);
  // 控制音频预览模态框显示状态
  const [showAudioPreviewModal, setShowAudioPreviewModal] = useState(false);
  // 控制修改名称模态框显示状态
  const [showChangeNameModal, setShowChangeNameModal] = useState(false);
  // 控制删除模态框显示状态
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // 当前操作的item
  const [currentItem, setCurrentItem] = useState({});
  // 定义更新列表的时间戳
  const [updateTimestamp, setUpdateTimestamp] = useState(null);
  // 定义新增voices的名字
  const [newVoiceName, setNewVoiceName] = useState('');
  // 录音结束后得到的文件
  const [recordedFile, setRecordedFile] = useState(null);
  const [voiceDeleteTime, setVoiceDeleteTime] = useState(null);
  const [voiceLanguage, setVoiceLanguage] = useState(0);

  /**
   * 关闭所有弹窗的方法
   */
  const CloseAllPupUp = useCallback(() => {
    setShowNotification(false);
    setShowCreateTypeModal(false);
    setShowUploadAudioModal(false);
    setShowRecordAudioModal(false);
    setShowAudioPreviewModal(false);
    setShowChangeNameModal(false);
    setShowDeleteModal(false);
  }, []);

  // 返回所有状态和方法
  return {
    tabActive,
    setTabActive,
    selectVoiceItem,
    setSelectVoiceItem,
    useVoiceItem,
    setUseVoiceItem,
    showVoiceLost,
    setShowVoiceList,
    // 通知显示状态
    showNotification,
    // 设置通知显示状态的函数
    setShowNotification,
    // 创建类型模态框显示状态
    showCreateTypeModal,
    // 设置创建类型模态框显示状态的函数
    setShowCreateTypeModal,
    // 上传音频模态框显示状态
    showUploadAudioModal,
    // 设置上传音频模态框显示状态的函数
    setShowUploadAudioModal,
    // 录音模态框显示状态
    showRecordAudioModal,
    // 设置录音模态框显示状态的函数
    setShowRecordAudioModal,
    // 音频预览模态框显示状态
    showAudioPreviewModal,
    // 设置音频预览模态框显示状态的函数
    setShowAudioPreviewModal,
    // 修改名称模态框显示状态
    showChangeNameModal,
    // 设置修改名称模态框显示状态的函数
    setShowChangeNameModal,
    // 删除模态框显示状态
    showDeleteModal,
    // 设置删除模态框显示状态的函数
    setShowDeleteModal,
    // 当前操作的项目
    currentItem,
    // 设置当前操作项目的函数
    setCurrentItem,
    // 设置更新时间戳的函数
    updateTimestamp,
    setUpdateTimestamp,
    // 新的语音名称
    newVoiceName,
    // 设置新的语音名称
    setNewVoiceName,
    // 录音结束后得到的文件
    recordedFile,
    // 设置录音结束后得到的文件
    setRecordedFile,
    CloseAllPupUp,
    voiceDeleteTime,
    setVoiceDeleteTime,
    voiceLanguage,
    setVoiceLanguage,
  };
};
